import { Button, Flex, Text, Tooltip } from '@mantine/core'

import { Icons } from 'src/common/components/ui'

import { RecordInformationTableData } from '../merging-tool.types'

export const getTableHeaders = (
  datafields: RecordInformationTableData[],
): {
  accessor: string
  title: React.JSX.Element
}[] => {
  return datafields.length
    ? Object.keys(datafields[0])
        .sort()
        .map((colHeader, idx) => ({
          accessor: colHeader,
          title: (
            <Flex justify="space-between" key={colHeader} p={8} align="center">
              <Tooltip label={colHeader}>
                <Text fw="700" ta="center" style={{ flexGrow: 1 }}>
                  {`Duplicate ${idx + 1}`}
                </Text>
              </Tooltip>
              <Button
                variant="unstyled"
                bg="transparent"
                component="a"
                data-disabled
                href={`leads/${colHeader}`}
                target="_blank"
              >
                <Icons.NewLinkTab style={{ cursor: 'pointer' }} />
              </Button>
            </Flex>
          ),
        }))
        .filter(
          ({ accessor }) =>
            !['field'].includes(accessor) && !['total'].includes(accessor),
        )
    : []
}
